export default "__VITE_ASSET__CxAeE2WB__"